export const environment = {
  production: true,
  imgHost: '/client/dist/assets/images/',
  apiHost: 'https://datalive-staging.appspot.com',
  smartWitnessBaseUrl: 'https://smartwitness.modularis.com',

  ssoAuthUrl: 'http://dashboard.datalive-staging.com/oauth2/',
  dataliveAuthHost: 'https://auth.datalive-staging.com',

  safetyInspectionAppUrl: 'https://safetyinspection.datalive-staging.com/app/',
  safetyInspectionApiHost: 'https://api-dot-earned-recognition-staging.appspot.com',
  defectAppUrl: 'https://defect.datalive-staging.com',
  defectApiHost: 'https://api-dot-datalive-defect-report-staging.appspot.com',
  vehicleCheckApiHost: 'https://datalive-vehicle-check-staging.nw.r.appspot.com',
  vehicleUtilisationAppUrl: 'https://utilisation.datalive-staging.com',
  externalAppKeys: {
    dpd: '046415967575bd5df4631598'
  },
  externalAppLinks: {
    ER_DASHBOARD: 'https://er.datalive-staging.com',
    SAFETY_INSPECTION: 'https://inspection.datalive-staging.com',
    DEFECT: 'https://defect.datalive-staging.com',
    DRIVER_AGENCY_ONBOARDING: 'https://agency.datalive-staging.com',
    FMT: 'checkit.datalive-staging.com',
    TACHOGRAF: 'https://idha.online/login'
  },
  developmentAccessToken: null
};



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/environments/environment.ts